import styled from 'helpers/styles';
import PropTypes from 'prop-types';
import ComponentStyles from 'styles/mixins/Component.styles';
import EntitiesViewBar from 'components/organisms/Bars/EntitiesViewBar/EntitiesViewBar';

const StyledCollectionEntitiesViewBar = styled(EntitiesViewBar)`
  ${ComponentStyles}
`;

StyledCollectionEntitiesViewBar.propTypes = {
  theme: PropTypes.object
};

export default StyledCollectionEntitiesViewBar;
